import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import SimpleReactValidator from 'simple-react-validator';

import Page from '../../../components/Page';
import DataTable from '../../../components/DataTable';
import { TabHolder, Tab } from '../../../components/Tabs';

import BlankState from '../../../components/BlankState';
import StatusMessages from '../../../components/StatusMessages';

import Utils from '../../../utils/mci-utils';
import {
  listVesselLimits,
  listConsignmentLimits,
  updateVesselLimits,
  updateConsignmentLimits
} from '../../../actions/limits';

class Limits extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vesselLimits: [],
      limits_loading: true,
      vesselLimit: {
        limit: ''
      },
      consignmentLimit: {
        limit: ''
      },
      vesselLimit_updating: false,
      consignmentLimit_updating: false
    };
    this.LimitValidator = new SimpleReactValidator();
    this.ConsignmentValidator = new SimpleReactValidator();
  }

  componentDidMount() {
    const { listConsignmentLimits, listVesselLimits } = this.props;
    let insurer = this.state.user ? this.state.user.userInfo.insurer : null;

    listConsignmentLimits(insurer);
    listVesselLimits(insurer);
  }

  onChangeVesselLimit = e => {
    const { name, value } = e.target;
    this.setState({
      vesselLimit: {
        [name]: value,
        insurer_name: this.state.user
          ? this.state.user.userInfo.insurer_name
          : null
      }
    });
  };

  onChangeConsignmentLimit = e => {
    const { name, value } = e.target;
    this.setState({
      consignmentLimit: {
        [name]: value,
        insurer_name: this.state.user
          ? this.state.user.userInfo.insurer_name
          : null
      }
    });
  };

  onAddVesselLimit = e => {
    e.preventDefault();
    if (this.LimitValidator.allValid()) {
      const { vesselLimit } = this.state;
      this.LimitValidator.hideMessages();
      let handler = {};
      if (vesselLimit) {
        handler = this.props.updateVesselLimits(vesselLimit);
        this.setState({
          vesselLimit: {
            limit: ''
          }
        });
      }
    } else {
      this.LimitValidator.showMessages();
      this.forceUpdate();
    }
  };

  onAddConsignmentLimit = e => {
    e.preventDefault();

    const { consignmentLimit } = this.state;
    if (this.ConsignmentValidator.allValid()) {
      this.ConsignmentValidator.hideMessages();
      let handler = {};
      if (consignmentLimit) {
        handler = this.props.updateConsignmentLimits(consignmentLimit);
        this.setState({
          consignmentLimit: {
            limit: ''
          }
        });
      }
    } else {
      this.ConsignmentValidator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    // console.log(this.state);
    const menuItems = [
      { id: 'limits', name: 'Vessel Limits', active: true },
      { id: 'consignment', name: 'Consignment Details' }
    ];

    let {
      limits_loading,
      vesselLimit_updating,
      consignmentLimit_updating
    } = this.state;
    let { limits } = this.props;

    return (
      <Page isAdminPage={true} pageTitle="Limits">
        <div className="clearfix">
          <TabHolder menuItems={menuItems}>
            <Tab menuId={menuItems[0].id} isActive={true}>
              <div className="col-md-12 filter-form">
                {limits &&
                limits.errorVesselLimitUpdate &&
                !vesselLimit_updating ? (
                  <StatusMessages
                    type="error"
                    message={limits.errorMessageVesselLimitUpdate}
                  />
                ) : null}
                {limits && limits.updated && !vesselLimit_updating ? (
                  <StatusMessages type="success" message={limits.updated} />
                ) : null}
                <form
                  id="vesselForm"
                  name="vesselForm"
                  className="form-inline"
                  noValidate
                >
                  <div className="form-group">
                    <input
                      id="vessel-limit"
                      type="number"
                      className="form-control"
                      placeholder="Enter Limit"
                      name="limit"
                      min="1"
                      value={this.state.vesselLimit.limit}
                      onChange={this.onChangeVesselLimit}
                    />
                  </div>

                  <button
                    id="vesselBtn"
                    className="btn btn-primary"
                    onClick={this.onAddVesselLimit}
                  >
                    Update Limit
                  </button>
                  {this.LimitValidator.message(
                    'limit',
                    this.state.vesselLimit.limit,
                    'required|gt:1',
                    'text-danger'
                  )}
                </form>
              </div>
              &nbsp;
              <div className="col-md-12 filter-form">
                {limits &&
                limits.vesselLimits &&
                limits.vesselLimits.length > 0 ? (
                  <DataTable
                    tableId="vessel-table"
                    columnTitles={['Date Created', 'Insurer', 'Limit (Tsh)']}
                  >
                    {limits.vesselLimits.map((limit, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            {moment(limit.created).format('MMM Do, YYYY')}
                          </td>
                          <td>{limit.insurer_name}</td>
                          <td>{Utils.parseAmount(limit.limit)}</td>
                        </tr>
                      );
                    })}
                  </DataTable>
                ) : (
                  <BlankState
                    data={limits ? limits.vesselLimits : {}}
                    dataName="Limits"
                    isDataLoading={limits_loading}
                  />
                )}
              </div>
            </Tab>

            <Tab menuId={menuItems[1].id}>
              <div className="col-md-12 filter-form">
                {limits &&
                limits.errorConsignmentLimitUpdate &&
                !consignmentLimit_updating ? (
                  <StatusMessages
                    type="error"
                    message={limits.errorMessageConsignmentLimitUpdate}
                  />
                ) : null}
                {limits && limits.success && !consignmentLimit_updating ? (
                  <StatusMessages type="success" message={limits.success} />
                ) : null}
                <form
                  id="consignmentForm"
                  name="vesselForm"
                  className="form-inline"
                  novalidate
                >
                  <div className="form-group">
                    <input
                      id="consignment-limit"
                      type="number"
                      className="form-control"
                      placeholder="Enter Limit"
                      name="limit"
                      min="1"
                      value={this.state.consignmentLimit.limit}
                      onChange={this.onChangeConsignmentLimit}
                    />
                  </div>

                  <button
                    id="consignmentBtn"
                    className="btn btn-primary"
                    onClick={this.onAddConsignmentLimit}
                  >
                    Update Limit
                  </button>
                  {this.ConsignmentValidator.message(
                    'limit',
                    this.state.consignmentLimit.limit,
                    'required|gt:0',
                    'text-danger'
                  )}
                </form>
                &nbsp;
              </div>

              {limits &&
              limits.consignmentLimits &&
              limits.consignmentLimits.length > 0 ? (
                <DataTable
                  tableId="details-table"
                  columnTitles={['Date Created', 'Insurer', 'Limit(Tsh)']}
                >
                  {limits.consignmentLimits.map((limitConsignment, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          {moment(limitConsignment.created).format(
                            'MMM Do YYYY'
                          )}
                        </td>
                        <td>{limitConsignment.insurer_name}</td>
                        <td>{Utils.parseAmount(limitConsignment.limit)}</td>
                      </tr>
                    );
                  })}
                </DataTable>
              ) : (
                <BlankState
                  data={limits ? limits.consignmentLimits : {}}
                  dataName="Consignment Limits"
                  isDataLoading={limits_loading}
                />
              )}
            </Tab>
          </TabHolder>
        </div>
      </Page>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  limits: state.limits
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      listVesselLimits,
      listConsignmentLimits,
      updateVesselLimits,
      updateConsignmentLimits
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Limits);



// WEBPACK FOOTER //
// ./src/pages/dashboard/rates/Limits.jsx